import React from 'react';
import { useTelegram } from '../../../hooks/useTelegram';
import { hapticFeedback } from '../../../utils/telegram';
import { shouldUseFullscreen, getDeviceType } from '../../../utils/deviceUtils';
import './FullscreenButton.css';

const FullscreenButton = ({ className = '', showLabel = true }) => {
  const { isFullscreen, fullscreenControls, isReady } = useTelegram();

  const handleFullscreenToggle = () => {
    hapticFeedback.medium();
    
    // Use the new toggle function that handles both request and exit
    const success = fullscreenControls.toggleFullscreen();
    
    if (!success) {
      // Fallback to expand if fullscreen API is not available
      fullscreenControls.expand();
    }
  };
  // Don't show button if not in Telegram or not on mobile device
  if (!isReady || !shouldUseFullscreen()) {
    return null;
  }

  return (
    <button 
      className={`fullscreen-button ${className} ${isFullscreen ? 'active' : ''}`}
      onClick={handleFullscreenToggle}
      title={isFullscreen ? 'Выйти из полноэкранного режима' : 'Включить полноэкранный режим'}
    >
      <div className="fullscreen-icon">
        {isFullscreen ? (
          // Exit fullscreen icon
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path 
              d="M5 16H8V19H5V16ZM16 8H19V5H16V8ZM8 8H5V5H8V8ZM16 16H19V19H16V16Z" 
              fill="currentColor"
            />
            <path 
              d="M9 9H15V15H9V9Z" 
              fill="currentColor" 
              opacity="0.6"
            />
          </svg>
        ) : (
          // Enter fullscreen icon
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path 
              d="M7 14H5V19H10V17H7V14ZM5 10H7V7H10V5H5V10ZM17 17H14V19H19V14H17V17ZM14 5V7H17V10H19V5H14Z" 
              fill="currentColor"
            />
          </svg>
        )}
      </div>
      {showLabel && (
        <span className="fullscreen-label">
          {isFullscreen ? 'Выйти' : 'Полный экран'}
        </span>
      )}
    </button>
  );
};

export default FullscreenButton; 